var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCandidaturaSponatanea(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.514,
    height: 29.606,
    viewBox: "0 0 38.514 29.606",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Candidatura_spontanea",
    "data-name": "Candidatura spontanea",
    transform: "translate(-1.35 -1.35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20865",
    "data-name": "Path 20865",
    d: "M106.986,13.667a5.667,5.667,0,1,0-5.667,5.667A5.667,5.667,0,0,0,106.986,13.667Z",
    transform: "translate(-85.717 -5.9)",
    fill: "none",
    stroke: "#045195",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20866",
    "data-name": "Path 20866",
    d: "M31.886,173.741A13.5,13.5,0,0,0,8,182.372",
    transform: "translate(-5.9 -152.39)",
    fill: "none",
    stroke: "#045195",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20867",
    "data-name": "Path 20867",
    d: "M201.587,151.411l5.737,5.457,13.662-13.432",
    transform: "translate(-182.183 -126.955)",
    fill: "none",
    stroke: "#045195",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandidaturaSponatanea);
export default __webpack_public_path__ + "static/media/candidatura_sponatanea.42e92e502a0486870be23aa3f76f4918.svg";
export { ForwardRef as ReactComponent };